import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireFunctions } from '@angular/fire/functions';
@Injectable({
    providedIn: 'root'
})
export class FichaService {


    constructor(private http: HttpClient, public db: AngularFireDatabase, private fns: AngularFireFunctions) { }


    getdata(colegio: string, cedula: string) {
        return this.http.get(`${environment.firebase.databaseURL + "/produccionV2"}/fichasHistoricas/${colegio}/${cedula}/.json`)
    }



    getFichaByColegioAndCedula(idColegio: string, cedula: string) {
        return new Observable<any>((observer) => {
            var suscripcion: any
            //  ejecutamos el servicio para obtener el array de cedulas
            suscripcion = this.db.object(environment.nodoAmbiente + '/fichas/' + idColegio + "/" + cedula).valueChanges().subscribe((resp: any) => {

                observer.next(resp);
            });
        })
    }



    EnvioEmail(idcolegio: string, linkPDF: string, CedulaEstudiante: string) {
        return new Observable<any>((observer) => {
            const callable = this.fns.httpsCallable('generaEmailBienvenida');
            const obs = callable({ IDColegio: idcolegio, linkPDF: linkPDF, CedulaEstudiante: CedulaEstudiante });
            obs.subscribe(async (res) => {

                observer.next(res);
            });
        });
    }




    /**************************
     * get rutas inscripcion
     */



    getRutasInscripcionByColegio(Idcolegio: string) {

        return new Observable<any>((observer) => {
          var subscribe = this.db
            .object(
              environment.nodoAmbiente + '/RutasIncripciones/' + Idcolegio)
            .valueChanges()
            .subscribe((resp: any) => {
              subscribe.unsubscribe();
              observer.next(resp);
            });
        });
      }
    


      /***********************
       * getRutasByColegioAndRutas
       */

      getRutasByColegioAndRutas(Idcolegio: string) {
        return new Observable<any>((observer) => {
          var subscribe = this.db.object(
            environment.nodoAmbiente + '/rutasAlumnos/' + Idcolegio).valueChanges().subscribe((resp: any) => {   
              const rutas: any[] = [];
              Object.keys(resp).forEach(key => {    
                rutas.push(key)
              }); 
              subscribe.unsubscribe();
              observer.next(rutas);
            });
        });   
      }
    
       

      /**********************
       * delete alumnos By ruta
       */
    
    
      deletealumnoByCedula(Idcolegio: string, ruta: string, cedula: string) {
        this.db.object(environment.nodoAmbiente + '/rutasAlumnos/' + Idcolegio + "/" + ruta + "/alumnos/" + cedula).remove();
      }


}